export default __webpack_public_path__ + "static/media/firasans-semibold.54b5ac3a.woff2";